import React from "react";
import PropTypes from "prop-types";
import Square from "./Square";
import { BarLoader } from "react-spinners";

class GridList extends React.Component {
    componentWillMount() {
        // Give sectors parent name & ID, push sectors to props
        for (
            let data = this.props.industries, i = 0, l = data.length;
            i < l;
            i++
        ) {
            let indus = data[i].id;
            let indusName = data[i].name;
            let squares = [];
            data[i].sectors.forEach(function(sectors) {
                sectors.parent = indus;
                sectors.parentName = indusName;
                squares.push(sectors.id);
            });
            data[i].squares = squares;
        }
    }

    render() {
        const { plate, items, name } = this.props;
        if (plate === undefined || items === undefined) {
            return (
                <div className="spinner-holder">
                    <BarLoader color={"#150F96"} />
                </div>
            );
        } else {
            const ln = plate.length;
            return (
                <dl className="grid__list">
                    <dt className="grid__heading">{name}</dt>
                    {ln > 0 ? (
                        plate
                            .sort(function(a, b) {
                                let initial = a.sectorName.toLowerCase(),
                                    next = b.sectorName.toLowerCase();
                                if (initial < next) return -1;
                                if (initial > next) return 1;
                                return 0;
                            })
                            .map((square, i) => (
                                <Square
                                    {...this.props}
                                    square={square}
                                    i={i}
                                    key={i}
                                    product={this.productId}
                                />
                            ))
                            .filter(square =>
                                square.props.items.includes(
                                    square.props.square.sectorId
                                )
                            )
                    ) : (
                        <div className="spinner-holder">
                            <BarLoader color={"#150F96"} />
                        </div>
                    )}
                </dl>
            );
        }
    }
}

export default GridList;



// WEBPACK FOOTER //
// ./src/components/GridList.js